import { render, staticRenderFns } from "./appAnnouncement.vue?vue&type=template&id=0c28b912&"
import script from "./appAnnouncement.vue?vue&type=script&lang=js&"
export * from "./appAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports